<!-- 底部 -->
<template>
  <footer class="footer">
    <div class="container">
      <div class="copy">
        <p>
          <span>主办单位：四川省建协人才服务中心</span>
          <span>承办单位：四川省建协人才服务中心</span>
          <span>地 址：四川省成都市</span>
          <span>邮 编：610000</span>
        </p>
        <p>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow"
            >蜀ICP备2021025200号</a
          >
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51142102511556"
            target="_blank"
            rel="nofollow"
          >
            <img src="@/assets/icon_05.png" alt="" />
            <span>川公网安备 51142102511556号</span>
          </a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    globalData: {
      type: Object,
      default: () => {},
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #363636;
  padding: 10px 0;
  color: #fff;

  .container {
    width: 1200px;
    margin: 0 auto;
    text-align: center;
    color: #fff;

    .copy {
      font-size: 13px;

      a {
        margin: 0 10px;
      }
      a:hover {
        text-decoration: underline;
      }
      span + span {
        margin-left: 20px;
      }
      p + p {
        margin-top: 5px;
      }
      img {
        vertical-align: middle;
        margin-right: 5px;
      }
    }
  }
}

@media (max-width: 750px) {
  .footer {
    padding: 10px;

    .container {
      color: #fff;
      width: 100%;

      .copy {
        p + p {
          margin-top: 0;
        }
      }

      .copy p > span,
      a {
        display: block;
        margin-bottom: 2px;

        & + span {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
